module.exports = __webpack_public_path__ + "img/ereszkalkulator_25_bilics_merete_jobb_szurke.4eb73f6f.png";